import React from 'react';
import { motion } from 'framer-motion';

const Companies: React.FC = () => {
  // Companies without a logo file render as a text wordmark
  const companies: { name: string; logo: string | null; website: string | null }[] = [
    {
      name: "Petrotreatment",
      logo: "/companies/petrotreatment.png",
      website: "https://www.petrotreatment.com"
    },
    {
      name: "Loxport",
      logo: "/companies/loxport.jpg",
      website: "https://loxport.com"
    },
    {
      name: "B+P GmbH",
      logo: "/companies/bp-group.jpg",
      website: null
    },
    {
      name: "CR Schwabe",
      logo: null,
      website: null
    },
    {
      name: "HTW Berlin",
      logo: "/universities/htw-berlin.webp",
      website: "https://www.htw-berlin.de/"
    },
    {
      name: "Metropolia",
      logo: "/universities/metropolia.png",
      website: "https://www.metropolia.fi/"
    },
    {
      name: "Cairo University",
      logo: "/universities/cairo-university.jpg",
      website: "https://cu.edu.eg/"
    }
  ];

  return (
    <section className="py-16 bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h3 className="text-lg font-semibold text-gray-600 mb-8">
            Trusted and Recommended by CEOs at Leading Companies & Alumni of Top Universities
          </h3>
        </motion.div>

        {/* Infinite Rotating Logo Carousel */}
        <div className="relative overflow-hidden">
          <motion.div
            animate={{ x: [0, -companies.length * 224] }}
            transition={{
              x: {
                repeat: Infinity,
                repeatType: "loop",
                duration: 30,
                ease: "linear",
              },
            }}
            className="flex items-center space-x-16 w-max"
          >
            {/* Triple logos for seamless infinite loop */}
            {companies.concat(companies).concat(companies).map((company, index) => (
              <motion.div
                key={`${company.name}-${index}`}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: (index % companies.length) * 0.1 }}
                viewport={{ once: true }}
                whileHover={{ scale: 1.15, rotate: 3, y: -5 }}
                className="flex-shrink-0"
              >
                <a
                  href={company.website ?? undefined}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block"
                >
                  <div className="w-40 h-24 bg-white rounded-2xl hover:shadow-2xl flex items-center justify-center transition-all duration-300 p-2">
                    {company.logo ? (
                      <img
                        src={company.logo}
                        alt={`${company.name} logo`}
                        className="max-w-full max-h-full object-contain grayscale hover:grayscale-0 opacity-80 hover:opacity-100 transition-all duration-500"
                      />
                    ) : (
                      <span className="text-xl font-bold text-gray-500 hover:text-primary-600 text-center leading-tight transition-colors duration-500">
                        {company.name}
                      </span>
                    )}
                  </div>
                </a>
              </motion.div>
            ))}
          </motion.div>
          
          {/* Gradient fade effects */}
          <div className="absolute left-0 top-0 w-32 h-full bg-gradient-to-r from-white to-transparent pointer-events-none"></div>
          <div className="absolute right-0 top-0 w-32 h-full bg-gradient-to-l from-white to-transparent pointer-events-none"></div>
        </div>

      </div>
    </section>
  );
};

export default Companies;